import Vue from "vue";

const file = require("../../public/forms_configuration/bankruptcy/list_of_courts.json");

export function getBankruptcyCourts() {
  // return an array of a bankruptcy courts
  return Array.prototype.concat.apply([], Object.values(file));
}

export function getBankruptcyCourtsNames() {
  // return an array of a bankruptcy courts names
  let all_courts = getBankruptcyCourts();
  return all_courts.map(item => {
    return item.name;
  });
}

export async function getBankruptcyCourtsForSelect(province, postal_code) {
  // return array of arrays used for render select options in a form
  // [{name:... id:..., group:...}...]
  if (Boolean(province) && Boolean(postal_code)) {
    let court_from_backend = await Vue.Courts.get_bankruptcy_court_from_backend(
      province,
      postal_code
    );
    var court_options = [];
    var provinces = Object.keys(file);

    if (court_from_backend != null) {
      court_options.push(court_from_backend);
      return court_options;
    }
  }
  if (provinces.includes(province)) {
    file[province].forEach(function(court) {
      court_options.push(court.name);
    });
  }
  return court_options;
}

export function getCourtData(court_name) {
  // get court data based on provided court name
  var courts = getBankruptcyCourts();
  var court = null;
  courts.forEach(function(element) {
    if (element.name == court_name) {
      court = element;
    }
  });
  return court;
}
